import React, { useState } from 'react';
import {
  Box,
  Menu,
  List,
  ListItem,
  Divider,
  Grid,
  useTheme,
  getLuminance,
  Typography,
  getContrastRatio
} from '@mui/material';
import imgByXnuupBlack from "@/main/assets/images/login/xnuup_main_logo_black.png";
import imgByXnuupWhite from "@/main/assets/images/login/xnuup_main_logo_white.png";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { RoutesConstants } from '@/main/routes/routesConstants';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import {
  getTranslateByKey,
  isShowElementActionForCreateRegisterByRoute
} from '@/main/services/utils';
import AvatarComponent from '../avatar/avatarComponent';

import { useStyles, ButtonCart } from './styles';
import { getCommonColors } from '@/main/style/styleMaterialUIGlobal';
import { OrderStepsEnum } from '@/main/services/enum/OrderStepsEnum';
import { useLogout } from '@/main/hooks/logoutHook';
import { useVisualIdentityReducer } from '@/main/store/visualIdentity';
import * as S from './styles';
import HeaderSupportContactsComponent from '../headerSupportContactsComponent/headerSupportContactsComponent';

interface HeaderUserBoxProps {
  user: {
    avatar: any | null;
    name: string | null;
    email: string | null;
  };
  companyTradeName: string | null;
  version: string | null;
}

export default function HeaderUserbox(props: HeaderUserBoxProps) {
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();
  const theme = useTheme();
  const commonColors = getCommonColors(theme);
  const { visualIdentity: visualIdentityReducer } = useVisualIdentityReducer();
  const textColor = theme.palette.getContrastText(visualIdentityReducer.colors?.headerColor);
  const headerLuminance = getLuminance(visualIdentityReducer.colors.headerColor);
  const byXnuupLogo = getContrastRatio(visualIdentityReducer.colors.headerColor, commonColors.white) < 3 ? imgByXnuupBlack : imgByXnuupWhite;

  const { onLogoutAsync } = useLogout();
  // Helpers
  const renderAvatar = () => {
    const avatar = (
      <AvatarComponent
        avatarStyle={{
          height: 35,
          width: 35,
          backgroundColor: headerLuminance > 0.5 ? commonColors.white : commonColors.black,
          color: headerLuminance > 0.5 ? commonColors.black : commonColors.white
        }}
        alt={props.user.name || ''}
        photo={props.user.avatar}
      />
    );
    return <Box>{avatar}</Box>;
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  async function handleLogout() {
    await onLogoutAsync();
  }

  function validateOptionUser() {
    const optionsUser = [
      {
        id: 'btn-menu-logout',
        text: getTranslateByKey('information.logout'),
        onClick: handleLogout,
        icon: (
          <ExitToAppIcon
            className={classes.iconUserBox}
            id="id-userLogout-btn-logout"
          />
        )
      }
    ];

    return optionsUser;
  }

  function handleCreateOrder() {
    window.location.href = `#${RoutesConstants.orderCreateOrder}?step=${OrderStepsEnum.VehicleInformation}`;
  }

  function renderButtonCreateOrder() {
    if (
      isShowElementActionForCreateRegisterByRoute(
        RoutesConstants.orderCreateOrder
      )
    ) {
      return (
        <ButtonCart
          type="button"
          onClick={handleCreateOrder}
          style={{ padding: '5px', color: textColor }}
          id="id-createOrder-btn-cartCreateOrder">
          <AddShoppingCartIcon fontSize="large" />
        </ButtonCart>
      );
    }

    return <></>;
  }

  return (
    <>
      {renderButtonCreateOrder()}
      <HeaderSupportContactsComponent />
      <button
        type="button"
        onClick={handleClick}
        className={`${classes.containerUser} text-left btn-inverse d-flex align-items-center`}
        id="id-userLogout-btn-containerUser">
        {renderAvatar()}
        <div
          className="d-flex flex-column justify-content-end"
          style={{ marginLeft: 5, paddingTop: 10 }}>
          <div className="font-weight-bold text-center line-height-1">
            <p className={classes.userName}>{props.companyTradeName}</p>
            <h6 className={classes.userName} >
              {props.user && props.user.name}
            </h6>
          </div>
          <div className="d-flex justify-content-end">
            {!!props.version && (
              <span className={classes.versionText}>{`v${props.version}`}</span>
            )}
          </div>
        </div>
        <span className="d-flex align-items-center" style={{ paddingLeft: 2 }}>
          <ExpandMoreIcon style={{ color: textColor }} />
        </span>
      </button>

      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center'
        }}
        onClose={handleClose}
        elevation={2}
        className="ml-2"
        style={{ zIndex: 1400 }}>
        <div className="dropdown-menu-right dropdown-menu-lg overflow-hidden p-0">
          <List className="text-left bg-transparent d-flex align-items-center flex-column">
            <Grid container spacing={2} style={{ marginLeft: 10 }}>
              <Grid item md={2}>
                <Box>{renderAvatar()}</Box>
              </Grid>
              <Grid item md={8}>
                <div
                  className={`font-weight-bold line-height-1 ${classes.popupUserName}`}>
                  {props.user && props.user.name}
                </div>
                <span className={`${classes.popupUserName}`}>
                  {props.user && props.user.email}
                </span>
              </Grid>
            </Grid>
            <Divider className="w-100 mt-2" />
            {validateOptionUser().map(option => (
              <ListItem
                key={option.id}
                onClick={() => option.onClick()}
                style={{ cursor: 'pointer' }}>
                {option.icon}
                <span className={classes.textUserBox}>{option.text}</span>
              </ListItem>
            ))}
          </List>
        </div>
      </Menu>
    </>
  );
}
